import type { Provision } from "@/features/provisions/types";
import { apiClient } from "@/lib/apiClient";

export type CreateProvisionPayload = {
  name: string;
  description?: string;
  measurementUnit: string;
  measurementPrecision: number;
  typeCode?: string;
};

/** Every field is optional: the API leaves a missing one untouched. */
export type UpdateProvisionPayload = Partial<CreateProvisionPayload>;

export type DeletedProvision = Provision & {
  isDeleted: boolean;
  deletedAt: string | null;
};

export const PROVISIONS_KEY = "provisions/";

export const listProvisions = async (): Promise<Provision[]> => {
  const provisions = await apiClient.get<Provision[]>(PROVISIONS_KEY);
  return Array.isArray(provisions) ? provisions : [];
};

export const createProvision = (payload: CreateProvisionPayload): Promise<Provision> =>
  apiClient.post<Provision>("provisions", payload);

export const updateProvision = (id: string, payload: UpdateProvisionPayload): Promise<Provision> =>
  apiClient.put<Provision>(`provisions/${id}`, payload);

export const deleteProvision = (id: string): Promise<DeletedProvision> =>
  apiClient.delete<DeletedProvision>(`provisions/${id}`);
